import { render } from "./SearchDropdown.vue?vue&type=template&id=ed50dddc"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script